<template>
  <div id="editAddressRoot">
    <div class="title">
      <p><span class="name" id="edit_address_title">新增地址</span><span class="back" @click="back()"  v-if="isApp!==2">返回<i
            class="backIcon">></i></span></p>
    </div>
    <div class="root-bg">
      <div class="space-layout"></div>
      <div class="flex-row edit-address-row ct">
        <div>收货人</div>
        <input class="flex" type="text" placeholder="请输入收货人姓名" maxlength="20" v-model="personName" />
      </div>
      <div class="line"></div>
      <div class="flex-row edit-address-row ct">
        <div>收货人手机号</div>
        <input class="flex" type="text" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入收货人手机号"
          maxlength="11" v-model="personPhone" />
          <!-- <van-field class="flex" v-model="personPhone" type="tel"  style="padding:0;margin-left:0"/> -->
      </div>
      <div class="line"></div>
      <div class="flex-row edit-address-row ct" v-on:click="addressSelect">
        <div>地址信息</div>
        <input class="flex" placeholder="请选择" readonly v-model="personAddress" />
        <img src="../../../assets/next.png">
      </div>
      <div class="line"></div>
      <div class="flex-row">
        <div class="edit-address-info m-top">详细地址</div>
        <textarea class="flex edit-address-info-txt" placeholder="如道路、门牌号、小区、楼栋号、单元 室等" maxlength="100"
          v-model="personAddressInfo"></textarea>
      </div>
      <div class="line"></div>
      <div class="flex-row edit-address-row ct">
        <div>邮编</div>
        <input class="flex" type="text" placeholder="(非必填)请输入邮编" maxlength="6" v-model="personCode" />
      </div>
      <div class="line"></div>
      <div class="edit-address-row2">
        <span>设为默认地址</span>
        <van-switch class="edit-address-switch" size="24px" v-model="personIsDefaultAddress" active-color="#c41335"
          inactive-color="#dad7db" />
      </div>
    </div>
    <div class="edit-address-bottom-layout" :style="{bottom: tabHeight+'px'}"
      v-bind:class="[showBtnLayout ? 'edit-address-bottom-layout-block' : 'edit-address-bottom-layout-none']">
      <button id="edit_address_btn" v-on:click="submitData" v-bind:style="{backgroundColor:btnBg}">添加</button>
    </div>
    <AreaView :show="showAddressDialog" @selectedArea="onAddressDialogSelect" />
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import AreaView from '../../../components/area-view'
import wxshare from '../../../wx/weixin'
export default {
  name: 'editAddress',
  components: { AreaView },
  data () {
    return {
      btnBg: '#FECDCD',
      editAddressType: 0, // 0表示新增；1表示修改
      editAddressBean: { // 地址修改实体类
        address: '',
        area: '',
        city: '',
        id: 0,
        is_default: 0,
        name: '',
        phone: '',
        province: '',
        user_id: 0,
        zip_code: ''
      },
      personName: '',
      personPhone: '',
      personAddress: '',
      province: '',
      city: '',
      area: '',
      personAddressInfo: '',
      personCode: '',
      personIsDefaultAddress: false, // 默认地址的开关
      showAddressDialog: false,
      docmHeight: 0,
      showHeight: 0,
      // https://my.oschina.net/u/4335170/blog/3335865
      showBtnLayout: true, // 输入法弹出需要将底部按钮隐藏
      tabHeight: 0,
      isApp : 0,
    }
  },
  methods: {
    updateBtnName: function () {
      const btn = document.getElementById('edit_address_btn')
      const title = document.getElementById('edit_address_title')
      switch (this.editAddressType) {
        case 0:
          btn.innerHTML = '保存地址'
          title.innerHTML = '新增收货地址'
          break
        case 1:
          btn.innerHTML = '确认修改'
          title.innerHTML = '修改收货地址'
          break
        default:
          btn.innerHTML = '保存地址'
          title.innerHTML = '新增收货地址'
          break
      }
    },
    addressSelect: function () {
      this.showAddressDialog = !this.showAddressDialog
    },
    onAddressDialogSelect: function (province, city, area, code) {
      this.showAddressDialog = false
      if (province.length <= 0) {
        return
      }
      this.province = province
      this.city = city
      this.area = area
      this.personAddress = province + ' ' + city + ' ' + area
    },
    submitData: function () {
      if (this.checkData(true)) {
        switch (this.editAddressType) {
          case 0:
            this.saveData()
            break
          case 1:
            this.updateData()
            break
          default:
            this.saveData()
            break
        }
      }else{
        console.log("checkData false");
      }
    },
    saveData: function () { // 新增地址
      const isDefault = this.personIsDefaultAddress ? 1 : 0
      const param = {
        phone: this.personPhone,
        name: this.personName,
        zip_code: this.personCode,
        province: this.province,
        city: this.city,
        area: this.area,
        address: this.personAddressInfo,
        is_default: isDefault
      }
      this.utils.POST(this.accountUrl + '/site/save', param, (resultData) => {
        if (resultData.success) {
          Toast('添加成功')
          this.back()
        }
      })
    },
    updateData: function () { // 修改地址
    console.log("localStorage.getItem('userinfo'):",localStorage.getItem('userinfo'))
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      const isDefault = this.personIsDefaultAddress ? 1 : 0
      const param = {
        id: this.editAddressBean.id,
        phone: this.personPhone,
        name: this.personName,
        user_id: userinfo.tails.userinfo[0].id,
        zip_code: this.personCode,
        province: this.province,
        city: this.city,
        area: this.area,
        address: this.personAddressInfo,
        is_default: isDefault
      }
      console.log("/site/update:",JSON.stringify(param))
      this.utils.POST(this.accountUrl + '/site/update', param, (resultData) => {
        if (resultData.success) {
          Toast('修改成功')
          this.back()
        }
      })
    },
    back: function () {
      this.$router.back(-1)
    },
    checkData: function (showToast) {
      const regex = '^[\u4E00-\u9FA50-9a-zA-Z()_\s（）——]+$'
      if (this.personName.length <= 0) {
        if (showToast) Toast('请输入收货人姓名')
        return false
      }
      if (!this.personName.match(regex)) {
        if (showToast) Toast('收货人姓名只能输入中文、英文、数字')
        return false
      }
      if (this.personPhone.length <= 0) {
        if (showToast) Toast('请输入收货人手机号')
        return false
      }
      if (!this.utils.isPhone(this.personPhone)) {
        if (showToast) Toast('收货人手机号输入不正确')
        return false
      }
      if (this.personAddress.length <= 0) {
        if (showToast) Toast('请选择地址信息')
        return false
      }
      if (this.personAddressInfo.length <= 0) {
        if (showToast) Toast('请输入详细地址')
        return false
      }
      // if (!this.personAddressInfo.match(regex)) {
      //   if (showToast) Toast('详细地址只能输入中文、英文、数字')
      //   return false
      // }
      if (this.personCode.length > 0) {
        const regexCode = '^[0-9]+$'
        if (this.personCode.length !== 6 || !this.personCode.match(regexCode)) {
          if (showToast) Toast('邮编输入不正确')
          return false
        }
      }
      return true
    },
    androidTabHeight: function (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 5
        }
      } else {
        this.tabHeight = this.tabHeight + parseInt(value)
      }
    }
  },
  mounted () {
    console.log('(this.$route.query.isApp:',this.$route.query.isApp,localStorage.getItem("isApp"));
    if(this.$route.query.isApp){
      this.isApp = parseInt(this.$route.query.isApp)
      localStorage.setItem("isApp",parseInt(this.$route.query.isApp))
    }else if(parseInt(localStorage.getItem("isApp"))){
      this.isApp = parseInt(localStorage.getItem("isApp"))
    }

    wxshare.wxShareHomePage('【中消在线】消防安全产品一站式采购平台', '品质保障，正品低价，支持线上交易', 'http://cdn.zxzx119.com/1294196519632633856')
    this.editAddressType = parseInt(this.$route.query.editAddressType)
    this.updateBtnName()
    if (this.editAddressType === 1) {
      // 赋值
      this.editAddressBean = this.$route.query.editAddressBean
      const bean = this.editAddressBean
      this.personName = bean.name
      this.personPhone = bean.phone
      this.province = bean.province
      this.city = bean.city
      this.area = bean.area
      this.personAddress = bean.province + ' ' + bean.city + ' ' + bean.area
      this.personAddressInfo = bean.address
      this.personCode = bean.zip_code
      this.personIsDefaultAddress = bean.is_default === 1
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
    // 立马获取初始值
    this.docmHeight = window.innerHeight
    window.onresize = () => { // window.onresize监听页面高度的变化
      return (() => {
        this.showHeight = window.innerHeight
      })()
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || 
        parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
         
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  },
  computed: { // 计算当前输入是否正确
    isAllOk: function () {
      return this.checkData(false)
    }
  },
  watch: { // 通过监听去改变按钮的颜色
    isAllOk: function (val) {
      if (val) {
        this.btnBg = '#C41335'
      } else {
        this.btnBg = '#FECDCD'
      }
    },
    showHeight: function () {
      let height = this.docmHeight * 0.2
      let onheight = this.docmHeight - this.showHeight
      if (onheight < height) {
        this.showBtnLayout = true
      } else {
        this.showBtnLayout = false
      }
    }
  }
}
</script>

<style scoped>
#editAddressRoot {
  background: #f2f2f2;
  min-height: 100vh;
}
.title {
  height: 50px;
  line-height: 50px;
  width: 100%;
  padding: 0 13px 0 13px;
  background: #ffffff;
  position: fixed;
  top: 0;
  z-index: 2;
  border-bottom-style: solid;
  border-bottom-color: #f2f2f2;
  border-bottom-width: 1px;
}
.name {
  font-size: 15px;
  color: #000000;
  font-weight: bold;
}
.back {
  float: right;
  font-size: 13px;
  color: #999999;
}
.backIcon {
  display: inline-block;
  vertical-align: top;
  margin-left: 5px;
  font-size: 13px;
  color: #999999;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.ct {
  align-items: center;
  justify-content: center;
}
.line {
  width: calc(100% - 13px);
  height: 1px;
  position: relative;
  margin-left: 13px;
  background: #f2f2f2;
}
.flex {
  flex: 1;
}
.m-top {
  margin-top: 13px;
}
.root-bg {
  background: white;
  position: relative;
  top: 50px;
}
.space-layout {
  width: 100%;
  height: 15px;
  background: #f2f2f2;
}
.edit-address-row,
.edit-address-row2 {
  width: 100%;
  height: 50px;
  position: relative;
}
.edit-address-row div,
.edit-address-info {
  width: 120px;
  margin-left: 13px;
  font-size: 14px;
  color: #333333;
}
.edit-address-row input {
  font-size: 14px;
  color: #333333;
}
.edit-address-info-txt {
  box-sizing: border-box;
  border: none;
  height: 80px;
  margin-right: 13px;
  padding-top: 13px;
  padding-bottom: 13px;
  color: black;
  font-size: 13px;
}
::-webkit-input-placeholder {
  /* 修改input placeholder文字颜色 */
  color: #bebebe;
}
:-moz-placeholder {
  /* 修改input placeholder文字颜色 */
  color: #bebebe;
}
:-ms-input-placeholder {
  /* 修改input placeholder文字颜色 */
  color: #bebebe;
}
.edit-address-row span {
  font-size: 14px;
  color: #bebebe;
}
.edit-address-row img {
  width: 6px;
  height: 11px;
  margin-right: 13px;
  margin-left: 13px;
}
.edit-address-row2 span {
  display: inline-block;
  font-size: 14px;
  color: black;
  margin-left: 13px;
  line-height: 50px;
}
.edit-address-switch {
  position: absolute;
  right: 13px;
  top: 13px;
}
.edit-address-bottom-layout {
  position: fixed;
  bottom: 0;
  background: white;
  height: 65px;
  width: 100%;
}
.edit-address-bottom-layout-none {
  display: none;
}
.edit-address-bottom-layout-block {
  display: block;
}
.edit-address-bottom-layout button {
  width: calc(100% - 13px * 2);
  height: 45px;
  position: relative;
  top: 10px;
  outline: none;
  color: white;
  font-size: 15px;
  border-radius: 4px;
  margin-left: 13px;
  margin-right: 13px;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/personCenter/editAddress.vue